"use client";

import { useAuth } from "@/components/auth-provider";
import { Skeleton } from "@/components/ui/skeleton";
import { useRouter } from "next/navigation";
import { ReactNode, useEffect } from "react";

type ProtectedRouteGuardProps = {
  children: ReactNode;
};

export function ProtectedRouteGuard({ children }: ProtectedRouteGuardProps) {
  const { claims, loading } = useAuth();

  const router = useRouter();

  useEffect(() => {
    if (!loading && !claims) {
      router.replace("/");
    }
  }, [loading, claims, router]);

  if (loading) {
    return (
      <div className="flex w-full flex-col gap-6 p-6">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (!claims) {
    return null;
  }

  return <>{children}</>;
}
